var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00006C7.6 4.00006 4 7.60006 4 12.0001C4 16.4001 7.6 20.0001 12 20.0001C16.4 20.0001 20 16.4001 20 12.0001C20 7.60006 16.4 4.00006 12 4.00006ZM12 17.0001C11.4 17.0001 11 16.6001 11 16.0001C11 15.4001 11.4 15.0001 12 15.0001C12.6 15.0001 13 15.4001 13 16.0001C13 16.6001 12.6 17.0001 12 17.0001ZM13.5 12.4001C13 12.7001 13 12.8001 13 13.0001V14.0001H11V13.0001C11 11.7001 11.8 11.1001 12.4 10.7001C12.9 10.4001 13 10.3001 13 10.0001C13 9.40006 12.6 9.00006 12 9.00006C11.6 9.00006 11.3 9.20006 11.1 9.50006L10.6 10.4001L8.9 9.40006L9.4 8.50006C9.9 7.60006 10.9 7.00006 12 7.00006C13.7 7.00006 15 8.30006 15 10.0001C15 11.4001 14.1 12.0001 13.5 12.4001Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/Tooltip.77c3dc4782e674288eeb33363e4de648.svg";
export { ForwardRef as ReactComponent };